function moveValidErrorAnchorFirst(){
	var target;
	if($('.is-invalid').length > 0){
		$('.headline-is-invalid').each(function(){
			target = $(this);
			return false;
		});
		var position = target.offset().top;
		$("html, body").animate({scrollTop:position}, 'fast', "swing");
	}
	return false;
}

$(function () {
	moveValidErrorAnchorFirst();
});